import React, { useState } from "react";
import {
  IoChevronDownOutline,
  IoChevronUpOutline,
  IoCreateOutline,
  IoTrashOutline,
} from "react-icons/io5";
import "../lessons.css"; // reuse existing styles

const TeacherLessons = () => {
  const [courses, setCourses] = useState([
    {
      id: 1,
      title: "React Course",
      description: "Learn React from basics to advanced",
      deadline: "2026-04-10",
    },
    {
      id: 2,
      title: "Node Course",
      description: "Backend development with Node.js",
      deadline: "2026-05-01",
    },
  ]);

  const [expandedCourse, setExpandedCourse] = useState(null);

  // Modal State
  const [lessonModal, setLessonModal] = useState(false);
  const [currentCourseId, setCurrentCourseId] = useState(null);
  const [editingLesson, setEditingLesson] = useState(null);
  const [lessonForm, setLessonForm] = useState({ title: "" });

  // Open modal to add lesson
  const openAddLesson = (courseId) => {
    setLessonForm({ title: "" });
    setCurrentCourseId(courseId);
    setEditingLesson(null);
    setLessonModal(true);
  };

  // Open modal to edit lesson
  const openEditLesson = (courseId, lesson) => {
    setLessonForm({ title: lesson.title });
    setCurrentCourseId(courseId);
    setEditingLesson(lesson);
    setLessonModal(true);
  };

  // Save lesson (add or edit)
  const handleSaveLesson = () => {
    if (!lessonForm.title.trim()) return;

    const updatedCourses = courses.map((course) => {
      if (course.id !== currentCourseId) return course;

      if (editingLesson) {
        // Edit lesson
        return {
          ...course,
          lessons: course.lessons.map((l) =>
            l.id === editingLesson.id ? { ...l, title: lessonForm.title } : l,
          ),
        };
      }

      // Add lesson
      return {
        ...course,
        lessons: [
          ...course.lessons,
          {
            id: Date.now(),
            title: lessonForm.title,
          },
        ],
      };
    });

    setCourses(updatedCourses);
    setLessonModal(false);
  };

  // Delete lesson
  const deleteLesson = (courseId, lessonId) => {
    const updated = courses.map((course) =>
      course.id === courseId
        ? {
            ...course,
            lessons: course.lessons.filter((l) => l.id !== lessonId),
          }
        : course,
    );

    setCourses(updated);
  };

  // Delete course
  const deleteCourse = (courseId) => {
    setCourses(courses.filter((c) => c.id !== courseId));
  };

  // Edit course placeholder
  const editCourse = (course) => {
    alert("Edit Course: " + course.title);
  };

  return (
    <div className="overview-container">
      <h2>Teacher Lessons</h2>

      <table className="lessons-table">
        <thead>
          <tr>
            <th>Title</th>
            <th>Description</th>
            <th>Deadline</th>

            <th>Course Actions</th>
          </tr>
        </thead>
        <tbody>
          {courses.map((course) => (
            <React.Fragment key={course.id}>
              <tr>
                <td>{course.title}</td>
                <td>{course.description}</td>
                <td>{course.deadline}</td>

                {/* Course Actions */}
                <td>
                  <button
                    className="edit-btn"
                    onClick={() => editCourse(course)}
                  >
                    <IoCreateOutline />
                  </button>
                  <button
                    className="delete-btn"
                    onClick={() => deleteCourse(course.id)}
                    style={{ marginLeft: "10px" }}
                  >
                    <IoTrashOutline />
                  </button>
                  <button
                    className="add-lesson-btn"
                    onClick={() => openAddLesson(course.id)}
                    style={{ marginLeft: "10px" }}
                  >
                    + Lesson
                  </button>
                </td>
              </tr>

              {/* Expanded Lessons Table */}
              {expandedCourse === course.id && (
                <tr>
                  <td colSpan="5">
                    <table className="inner-table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Lesson Title</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {course.lessons.map((lesson, index) => (
                          <tr key={lesson.id}>
                            <td>{index + 1}</td>
                            <td>{lesson.title}</td>
                            <td>
                              <button
                                className="edit-btn"
                                onClick={() =>
                                  openEditLesson(course.id, lesson)
                                }
                              >
                                <IoCreateOutline />
                              </button>
                              <button
                                className="delete-btn"
                                onClick={() =>
                                  deleteLesson(course.id, lesson.id)
                                }
                                style={{ marginLeft: "10px" }}
                              >
                                <IoTrashOutline />
                              </button>
                            </td>
                          </tr>
                        ))}

                        {course.lessons.length === 0 && (
                          <tr>
                            <td colSpan="3" className="no-lessons">
                              No lessons
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>

      {/* Modal */}
      {lessonModal && (
        <div className="modal-overlay" onClick={() => setLessonModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>{editingLesson ? "Edit Lesson" : "Add Lesson"}</h3>
            <input
              type="text"
              placeholder="Lesson title"
              value={lessonForm.title}
              onChange={(e) => setLessonForm({ title: e.target.value })}
            />
            <div style={{ marginTop: "15px" }}>
              <button className="add-lesson-btn" onClick={handleSaveLesson}>
                {editingLesson ? "Update" : "Create"}
              </button>
              <button
                style={{ marginLeft: "10px" }}
                onClick={() => setLessonModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TeacherLessons;
